import type { User } from "@swift/shared";

/*
 * Mensen zoeken op naam.
 *
 * De weergavenaam is sinds 08-09-2026 het label uit de planning - "Aniek",
 * "Bart" - en dat is waar iemand naar zoekt. De gebruikersnaam ("avdberg") mag
 * ook, want die staat in de zijbalk achter de naam en wie hem kent typt hem.
 */

/** Kleinletters en zonder accenten, zodat "melusine" ook Mélusine vindt. Wie
 *  een trema moet typen om een collega te vinden, vindt hem niet. */
function plat(tekst: string): string {
  return tekst
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();
}

/**
 * De mensen die bij deze zoekterm passen, beste eerst.
 *
 * Volgorde: wie met de term begínt staat boven wie hem ergens in het midden
 * heeft. Bij "an" is Aniek relevanter dan Susanne, en dat is precies wat je
 * verwacht als je aan het typen bent.
 */
export function zoekPersonen(
  users: Record<number, User>,
  term: string,
  eigenId: number | undefined,
  maximaal = 6,
): User[] {
  const t = plat(term.trim());
  if (t.length === 0) return [];

  const treffers: Array<{ user: User; rang: number }> = [];
  for (const u of Object.values(users)) {
    if (u.id === eigenId) continue;
    const naam = plat(u.display_name);
    const gebruikersnaam = plat(u.username);

    let rang: number;
    if (naam.startsWith(t)) rang = 0;
    else if (gebruikersnaam.startsWith(t)) rang = 1;
    else if (naam.includes(t)) rang = 2;
    else if (gebruikersnaam.includes(t)) rang = 3;
    else continue;

    treffers.push({ user: u, rang });
  }

  treffers.sort(
    (a, b) => a.rang - b.rang || a.user.display_name.localeCompare(b.user.display_name),
  );
  return treffers.slice(0, maximaal).map((x) => x.user);
}
